import React, { FC, useEffect, useState } from 'react';
import { Swiper } from 'swiper/react';
import { Swiper as SwiperClass, SwiperOptions } from 'swiper/types/';
import { Styles } from './styles';
import { Arrow } from '../Arrow/Arrow';
import { defaultTheme } from 'constants/theme/defaultTheme';

import 'swiper/css';

export const Slider: FC<{
  whiteArrowBg?: boolean;
  breakpoints?: SwiperOptions['breakpoints'];
  centerInsufficientSlides?: SwiperOptions['centerInsufficientSlides'];
}> = ({ children, breakpoints, centerInsufficientSlides, whiteArrowBg }) => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass | null>(null);
  const [isEnd, setIsEnd] = useState<boolean>(false);
  const [isBeginning, setIsBeginning] = useState<boolean>(false);
  const breaks = breakpoints || {
    400: { slidesPerView: 2 },
    600: { slidesPerView: 3 },
    900: { slidesPerView: 4 },
    1090: { slidesPerView: 5 },
  };
  const [hideNavigation, setHideNavigation] = useState(true);

  const onNext = () => {
    swiperRef?.slideNext();
    onChange();
  };

  const onPrevious = () => {
    swiperRef?.slidePrev();
    onChange();
  };

  useEffect(() => {
    onChange();
  }, [swiperRef]);

  const onChange = () => {
    if (swiperRef) {
      setIsEnd(swiperRef.isEnd);
      setIsBeginning(swiperRef.isBeginning);
      setHideNavigation(swiperRef.isEnd && swiperRef.isBeginning);
    }
  };

  return (
    <Styles.Container>
      {!hideNavigation && (
        <Styles.Prev>
          <Arrow
            backgroundColor={
              whiteArrowBg ? defaultTheme.colors.white : defaultTheme.colors.whiteSmoke
            }
            direction="left"
            disabled={isBeginning}
            onClick={onPrevious}
          />
        </Styles.Prev>
      )}
      <Swiper
        centerInsufficientSlides={centerInsufficientSlides}
        spaceBetween={40}
        slidesPerView={1}
        onSlideChange={onChange}
        onSwiper={setSwiperRef}
        breakpoints={breaks}
      >
        {children}
      </Swiper>

      {!hideNavigation && (
        <Styles.Next>
          <Arrow
            disabled={isEnd}
            hideWhenDisabled
            backgroundColor={
              whiteArrowBg ? defaultTheme.colors.white : defaultTheme.colors.whiteSmoke
            }
            onClick={onNext}
          />
        </Styles.Next>
      )}
    </Styles.Container>
  );
};
